// extracted by mini-css-extract-plugin
export var container = "header-module--container--TrWYl";
export var head = "header-module--head--VdVG3";
export var svg = "header-module--svg--S9FGF";
export var lottie = "header-module--lottie--E8lF0";
export var logo = "header-module--logo--fvgEp";
export var intro = "header-module--intro--YAz8U";
export var sponsor = "header-module--sponsor--4hHZz";
export var btns = "header-module--btns--EZdiw";